import { createContext } from 'react';

export const AvailableCabinBagsContext = createContext({
  data: null,
  errors: null,
  loading: false,
});
